import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { QRCodeSVG } from "qrcode.react";
import { isSSR } from "@/lib/isSSR";

interface DealerQRCodeProps {
  dealerId: string;
  dealerName: string;
  city?: string;
}

export function DealerQRCode({ dealerId, dealerName, city }: DealerQRCodeProps) {
  // Skip rendering QR code during SSR
  if (isSSR()) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Codice QR</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col items-center">
          <div className="w-[200px] h-[200px] bg-muted rounded-md flex items-center justify-center">
            <span className="text-sm text-muted-foreground">QR Code</span>
          </div>
          <p className="text-xs text-muted-foreground mt-2 text-center">
            Scansiona per condividere questo commerciante
          </p>
        </CardContent>
      </Card>
    );
  }

  // Format city for URL if available
  const formattedCity = city ? city.toLowerCase().replace(/\s+/g, '-') : '';
  
  // Create the URL for the dealer page
  const baseUrl = window.location.origin;
  const dealerUrl = formattedCity 
    ? `${baseUrl}/compro-oro/${formattedCity}/${dealerId}`
    : `${baseUrl}/compro-oro/dettaglio/${dealerId}`;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Codice QR</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col items-center">
        <QRCodeSVG
          value={dealerUrl}
          size={200}
          bgColor={"#ffffff"}
          fgColor={"#000000"}
          level={"H"}
          includeMargin={false}
        />
        <p className="text-xs text-muted-foreground mt-2 text-center">
          Scansiona per condividere questo commerciante
        </p>
      </CardContent>
    </Card>
  );
}
